<template>
	<!--帖子标题 -->
	<div class="tieziInfoBox">
		<!-- 头部 -->
		<van-sticky>
			<div class="headerBox">
				<img src="../../assets/img/myicon/indexBgc02.png" alt="" class="backImg">
				<div class="headerQuery">
					<div class="arrImg" @click="$router.go(-1)">
						<img src="../../assets/img/leftarr_tit.png" alt="">
					</div>
					<p class="header_titile">回复</p>
				</div>
			</div>
		</van-sticky>
		<div class="hot_htBox">
			<div class="content">
				<span v-show="is_content && detail == ''">帖子内容</span>
				<editor-bar v-model="detail" :isClear="isClear" @change="change"></editor-bar>
			</div>
			<div class="fixed_footerBox">
				<!-- <div>
					<img src="../../assets/img/myicon/ltsmile.png" alt="">
					<img src="../../assets/img/myicon/ltimg.png" alt="">
					<img src="../../assets/img/myicon/lticon.png" alt="">
				</div> -->
				<div>
					<div class="radio_nm">
						<van-checkbox v-model="scRadio" checked-color="#ffdd2b" label-position="left">匿名</van-checkbox>
					</div>
					<div class="fb_btn">
						<button @click="add_forum">发送</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		Toast
	} from 'vant';
	import EditorBar from '../../components/wangEnduit.vue'

	export default {
		components: {
			EditorBar
		},
		data() {
			return {
				scRadio: false,
				isClear: false,
				detail: "",
				actidx:0,
				is_content: true,
				isClear: false,
			}
		},
		created() {
			this.detail = this.$route.query.content;
		},
		methods: {
			backForum() {
				this.$router.go(-1);
			},
			change(val) {
				this.detail = val;
				var reg = /<\/?.+?\/?>/g;
				var t_content = val.replace(reg,'');
				if(t_content){
					this.is_content = false;
				}else{
					this.is_content = true;
				}
			},
			add_forum(){
				if (!localStorage.getItem('userInfoData')) {
					this.$toast('您还没有登录，不能发帖哟!');
				} else {
					this.$axios.post(this.$api.reply_forum, {
						forum_id: this.$route.query.forum_id,
						comment_id: this.$route.query.comment_id || '',
						content:this.detail,
						anonymous: this.$route.query.anonymous || Number(this.scRadio),
					}).then(res => {
						if (res.data.code == 1) {
							// this.sendFn = false;
							this.sendValue = '',
							Toast(res.data.msg);
							this.$router.go(-1);
						} else {
							Toast(res.data.msg);
						}
				
					})
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	.tieziInfoBox {
		background-color: #fff;
		height: 100vh;
		width: 100vw;
		overflow: hidden;

		// 头部
		.headerBox {
			height: 160px;
			background-color: #fff;
			display: flex;
			position: relative;
			
			.backImg{
				position: absolute;
				bottom: 10px;
				left:0;
				width:100%;
			}

			.headerQuery {
				margin-top: 80px;
				padding: 0 20px;
				position: relative;
				display: flex;
				width: 100%;
				height: 80px;
				line-height: 80px;
				color: #000;
				border-bottom: 1px solid #f0f0f0;

				.arrImg {
					img {
						width: 40px;
						position: absolute;
						top: 50%;
						transform: translateY(-50%);
						left: 0px;
					}
				}

				.header_titile {
					flex: 1;
					text-align: center;
					font-size: 34px;
					/*px*/
				}
			}

		}

		//热门话题
		.hot_htBox {
			.scroll_bigBox {
				width: calc(100vw - 40px);
				height: 130px;
				overflow: scroll;
				padding: 0 20px;
				.scroll_box {
					height: 60px;
					padding-top: 40px;
					overflow-x: scroll;
					overflow-y: hidden;
					span {
						border: 1px solid #f5f5f5;/*no*/
						color: #000;
						border-radius: 50px;
						margin-right: 20px;
						width: 200px;
						height: 50px;
						line-height: 50px;
						text-align: center;
						display: inline-block;
						overflow: hidden;
						background-color: #f5f5f5;
					}
					.active{
						background-color: #ffdd2b;
						color: #fff;
					}
				}
			}

			.bottom_bm {
				border-top: 1px solid #f0f0f0;
				/*no*/
				border-bottom: 1px solid #f0f0f0;
				/*no*/
				line-height: 80px;
				margin: 0 16px;
				display: flex;

				span {
					font-weight: 600;
					font-size: 30px;
					/*px*/
					color: #bcbcbc;
				}

				input {
					font-size: 34px !important;
					/*px*/
					flex: 1;
					padding-left: 20px;
					color: #000;
					font-weight: bold;
				}
				input::placeholder{
					// color: #000;
					font-size: 34px !important;
					font-weight: normal;
					/*px*/
				}
			}

			.content {
				position: relative;
				margin-top:20px;
				
				span {
					font-size: 30px;
					/*px*/
					line-height: 46px;
					padding-left: 20px;
					color: #D3D3D3;
					position: absolute;
					top:72px;
					left:15px;
				}
				/deep/ .w-e-text{
					padding:0 20px 0 36px;
					
					/deep/  p{
						font-size: 34px;
						color: #000;
					}
				}
				.textareaBox {
					position: relative;
					padding-bottom: 30px;

					textarea {
						padding-top: 10px;
						width: calc(100vw - 32px);
						border: 0;
						height: 150px;
						color: #3d3d3d;
						text-indent: 1em;

						&::placeholder {
							font-size: 24px;
							/*px*/
						}
					}
				}
			}

			.fixed_footerBox {
				position: fixed;
				bottom: 0;
				left: 50%;
				width: calc(50vw - 40px);
				padding: 20px;
				// width: calc(100vw - 40px);
				display: flex;

				div {
					flex: 1;

					img {
						width: 50px;
						height: 50px;
						margin-right: 30px;
					}
				}

				div {
					flex: 1;
					display: flex;

					.radio_nm {
						flex: 1;
						text-align: right;

						/deep/.van-radio-group {
							/deep/.van-radio__icon .van-icon {
								width: 30px;
								height: 30px;
								line-height: 30px;
								font-size: 24px;
							}

							/deep/.van-radio__label {
								font-size: 22px;
								/*px*/
							}
						}
					}

					.fb_btn {
						flex: 1;
						position: relative;

						button {
							border: 0;
							background-color: #ffdd2b;
							color: #fff;
							height: 50px;
							/*px*/
							line-height: 50px;
							/*px*/
							width: 150px;
							border-radius: 50px;
							position: absolute;
							top: 50%;
							left: 50%;
							transform: translate(-50%, -50%);
						}
					}
				}
			}
		}
	}
</style>
